import { IdCard } from 'lucide-react';
import { useId } from 'react';

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@summer/ui-mosaic';

export type LegalProfilePresence = {
  ssnOnFile: boolean;
  spouseSsnOnFile: boolean;
  driversLicenseOnFile: boolean;
};

const PRESENCE_ROWS: ReadonlyArray<{
  key: keyof LegalProfilePresence;
  label: string;
}> = [
  { key: 'ssnOnFile', label: 'SSN' },
  { key: 'spouseSsnOnFile', label: "Spouse's SSN" },
  { key: 'driversLicenseOnFile', label: "Driver's license" },
];

const headerCellClasses = 'text-left p-3 font-semibold';
const bodyCellClasses = 'text-left p-3';

type LegalProfileProps = {
  legalProfile?: LegalProfilePresence;
};

const LegalProfile = ({ legalProfile }: LegalProfileProps) => {
  const titleId = `${useId()}-legal-profile`;

  if (!legalProfile) {
    return null;
  }

  return (
    <div className="my-6">
      <Accordion type="single" collapsible>
        <AccordionItem value="legal-profile" className="hover:bg-white">
          <AccordionTrigger>
            <div className="pl-3 flex items-center gap-2">
              <div className="flex items-center justify-center w-6 h-6 rounded-lg">
                <IdCard size={16} />
              </div>
              <span id={titleId}>Identity info</span>
            </div>
          </AccordionTrigger>
          <AccordionContent>
            <table
              className="w-full border-collapse mt-4"
              aria-labelledby={titleId}
            >
              <thead>
                <tr className="border-b">
                  <th className={headerCellClasses} scope="col">
                    Item
                  </th>
                  <th className={headerCellClasses} scope="col">
                    Provided
                  </th>
                </tr>
              </thead>
              <tbody>
                {PRESENCE_ROWS.map(({ key, label }) => (
                  <tr key={key} className="border-b">
                    <th
                      className={`${bodyCellClasses} font-normal`}
                      scope="row"
                    >
                      {label}
                    </th>
                    <td className={bodyCellClasses}>
                      {legalProfile[key] ? 'Yes' : 'No'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default LegalProfile;
